import { template } from '@yola/ws-sdk';
import { camelCaseObjectToSnakeCase } from 'src/js/modules/utils/convert-case';
import getContrastAdaptedColors from '../get-contrast-adapted-colors';
import sortSurfaces from '../sort-surfaces';
import getFallbackColorScheme from '../../../website-design/helpers/get-fallback-color-scheme';
import variableNames from '../../../website-design/constants/variable-names';
import { resolveVisualPreviewColor } from '../../../website-design/helpers/resolve-visual-preview-color';

const createOptions = ({ item, colorPalette }) => {
  const contrastColors = getContrastAdaptedColors(colorPalette.colors);

  return sortSurfaces(item.options).map((o) => {
    const scheme = colorPalette.schemes?.[o.value];
    const color =
      scheme?.variableOverrides?.[variableNames.BLOCK_BACKGROUND] ||
      scheme?.baseColor ||
      contrastColors[o.value];
    const overrides = scheme?.variableOverrides || {};
    const { backgroundColor, isDarkTheme } = resolveVisualPreviewColor({
      color,
      overrides: camelCaseObjectToSnakeCase(overrides),
    });

    return { ...o, backgroundColor, isDarkTheme };
  });
};

const normalizeSurfaceValue = ({ value, options }) =>
  value && !options.some((option) => option.value === value)
    ? getFallbackColorScheme(value)
    : value;

const createSurfaceOption = ({
  item,
  colorPalette,
  blockNode,
  elementId,
  displayOptions,
  onClick,
  onToggle,
}) => {
  if (!colorPalette || !colorPalette.colors) return null;

  const options = createOptions({ item, colorPalette });

  const existedOption = displayOptions && displayOptions.find((option) => option.id === item.id);
  const index = Number.isInteger(item.index) ? item.index : 0;
  const attributeValue = blockNode.getAttribute(item.attribute);
  const surfaces = attributeValue.split(' ').filter(Boolean);
  const surfaceValue = normalizeSurfaceValue({
    value: surfaces[index] || null,
    options,
  });

  const initialValue = existedOption ? existedOption.initialValue : surfaceValue;

  return {
    ...item,
    elementId,
    initialValue,
    onClick,
    onToggle,
    surfaces,
    options,
    value: surfaceValue,
    title: template.accessors.getMetaTranslations(item.title),
    subtitle: template.accessors.getMetaTranslations(item.subtitle),
  };
};

export default createSurfaceOption;
